__turbopack_context__.v({
  "aboutLabel": "EditTeamDetailsForm-module-scss-module__1mviLW__aboutLabel",
  "aiBadge": "EditTeamDetailsForm-module-scss-module__1mviLW__aiBadge",
  "checkboxLabel": "EditTeamDetailsForm-module-scss-module__1mviLW__checkboxLabel",
  "checkboxText": "EditTeamDetailsForm-module-scss-module__1mviLW__checkboxText",
  "form": "EditTeamDetailsForm-module-scss-module__1mviLW__form",
  "imageRow": "EditTeamDetailsForm-module-scss-module__1mviLW__imageRow",
  "panel": "EditTeamDetailsForm-module-scss-module__1mviLW__panel",
});
